import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "bg-gray-400 bg-opacity-50 flex fixed w-full h-screen items-center justify-center",
  style: { top: '0px', left: '0px' }
}
const _hoisted_2 = { class: "flex flex-col modal-box w-96" }
const _hoisted_3 = { class: "flex flex-col gap-4 p-2 w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-title" }, "Are you sure you want to remove this?")
], -1)
const _hoisted_5 = { class: "flex justify-around" }
const _hoisted_6 = { class: "button" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase font-bold px-11" }, "No", -1)
const _hoisted_8 = [
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", {
              class: "uppercase font-bold px-11",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onDelete && _ctx.onDelete(...args)))
            }, "Yes")
          ]),
          _createElementVNode("div", {
            class: "button-white border-2",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, _hoisted_8)
        ])
      ])
    ])
  ]))
}